import type { Currency } from './getCurrencyRates';
import { USD_CURRENCY, UAH_CURRENCY, EUR_CURRENCY } from './getProductCurrency';

const calculateRates = (rates: Currency[]) => {
  const getUahRate = (code: number): number => {
    const quote = rates.find((rate) => rate.currencyCodeA === code && rate.currencyCodeB === UAH_CURRENCY.code);
    const value = [quote?.rateBuy, quote?.rateSell, quote?.rateCross].find(
      (rate): rate is number => typeof rate === 'number' && Number.isFinite(rate) && rate > 0
    );
    if (!value) throw new Error('Currency rates are unavailable.');
    return value;
  };

  const usdToUah = getUahRate(USD_CURRENCY.code);
  const eurToUah = getUahRate(EUR_CURRENCY.code);
  const usdToEur = usdToUah / eurToUah;
  if (!Number.isFinite(usdToEur) || usdToEur <= 0) throw new Error('Currency rates are unavailable.');

  return {
    USD: 1,
    UAH: usdToUah,
    EUR: usdToEur,
  };
};

export default calculateRates;
